import React from 'react';
import urls from '../configs/urls'
import { Redirect} from 'react-router'
import '../css/Shop.css';
import '../css/Services.css';
import ls from 'local-storage'
import axios from 'axios';
import Retry from "./Retry";
import AppBody from "./AppBody";
import Khadamati from "../Modules/Khadamati";
class ServiceShow extends React.Component{
    list =[];
    hasMoreProductToLoad = true;
    content = document.getElementsByClassName("content")[0];
    constructor(props){
        super(props);
        this.state = {
            redirect: false,
            retry: false,
            error: false,
            error_text: "",
            loading: true,
            image:"",
            text:"",
            phone:"",
            service:null,
            id:ls.get("service_id"),
            active_menu:1

        };

    }

    componentDidMount = () => {
        if(ls.get("service_id") == null)
            this.props.history.push("/home");
        this.getService();
    };

    render() {
        if(this.state.redirect)
            return (<Redirect push to={this.state.url}/>);
        if(this.state.retry)
            return (<Retry url={"/home"} type={"RELOAD"} text={"در اجرای درخواست مشکلی پیش آمده است. لطفا مجددا تلاش کنید."}/>);
        if(this.state.error)
            return (
                <div className="App-body bg-white">
                    <div className={"infoMessage"}>
                        {this.state.error_text}
                    </div>
                    <form onSubmit={this.handleSubmit}>
                        <input type={"submit"} className={"btn submitPhone"} value={"صفحه اصلی"}/>
                    </form>
                </div>
            );


        return (
            <AppBody loading={this.state.loading} name={"خدماتی"} type={" alice"}>
                <div id={"ServiceSlider"}>
                    <img className={"ServiceSliderImg"} src={(this.state.service)?urls.SiteUrl+"upload/"+this.state.service.img:""}/>;
                </div>
                <a href={"tel:"+this.state.phone} className={"btn btn-success"} id={"serviceShowPhone"}><i className="serviceItemText glyphicon glyphicon-earphone"/></a>
                <div id={"serviceShowNavRow"}>
                    <button className={"ServiceCategory"+((this.state.active_menu === 0)?" active":"")} onClick={(e)=>this.switchTabs(e,this,0)}>نظرات</button>
                    <button className={"ServiceCategory"+((this.state.active_menu === 1)?" active":"")} onClick={(e)=>this.switchTabs(e,this,1)}>توضیحات</button>
                </div>
                <div id={"serviceShowArea"}>
                    {(this.state.active_menu && this.state.service)?this.state.service.text:""}
                </div>

            </AppBody>
        );
    }


    switchTabs(event,elm,type){
        let navs = document.getElementsByClassName("ServiceCategory");
        for (let i = 0; i < navs.length; i++)
            navs[i].className = "ServiceCategory";
        event.target.className += " active";

        this.setState({active_menu:type});
    }
    getService=()=>{
        this.setState({loading:true});
        axios.get(urls.baseUrl+urls.serviceShow+"?id="+this.state.id)
            .then(res => {
                if(res.data.code == 200){
                    this.setState({
                        service:new Khadamati(res.data.khadamati),
                        phone:res.data.user.phone,
                        loading:false
                    });
                }
                else{
                    alert(res.data.message())
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({retry:true,loading:false});
            });
    }
}



export default ServiceShow;
